export const OpenSans = 'OpenSans';
export const Montserrat = 'Montserrat, Bitter, Source Sans Pro, and Domine.';
export const Roboto = 'Roboto';
